import { Link } from "react-router-dom";
import { useFeatures } from "../../hooks/useFeatures.js";
import { MotdDocument } from "./MotdDocument.js";
import "./motd-prose.css";
import { motdChannelForEnv } from "./channel.js";
import { useMotdCurrent } from "./useMotd.js";

/** Login MOTD — navy header document matching Monday status email template. */
export function MotdBanner(): JSX.Element | null {
  const { deployEnv, isLoading: featuresLoading } = useFeatures();
  const channel = motdChannelForEnv(deployEnv);
  const { data, isLoading, isError } = useMotdCurrent(channel);

  if (featuresLoading || channel == null) return null;
  if (isLoading || isError || !data) return null;

  const archiveTo = data.archiveHref ?? "/motd";

  return (
    <aside className="w-full border-b border-slate-200 bg-slate-100/80 px-4 py-4 sm:px-6">
      <div className="mx-auto max-w-3xl">
        <MotdDocument
          entry={data}
          bodyClassName="max-h-[min(42vh,22rem)] overflow-y-auto"
          footer={
            <div className="flex items-center justify-between gap-3">
              <span className="tabular-nums">{data.date}</span>
              <Link to={archiveTo} className="font-medium text-[#0b5cab] underline-offset-2 hover:underline">
                Past Message Archive
              </Link>
            </div>
          }
        />
      </div>
    </aside>
  );
}
